export const HERO_IMG =
  "https://images.unsplash.com/photo-1694282881698-d0197b47305e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxwaW5lJTIwZm9yZXN0JTIwbWlzdHklMjBtb3JuaW5nfGVufDB8fHx8MTc4NjIxNzQxOHww&ixlib=rb-4.1.0&q=85";

export const PORTRAIT_IMG =
  "https://images.unsplash.com/photo-1607880609114-742ed2638069?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxvdXRkb29yJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg2MjE3NDE4fDA&ixlib=rb-4.1.0&q=85";

export const CATEGORIES = [
  {
    slug: "fiske",
    label: "Fiske",
    num: "01",
    img: "https://images.unsplash.com/photo-1783192580972-ced8f8885ca9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxmbHklMjBmaXNoaW5nJTIwcHJpc3RpbmUlMjBsYWtlfGVufDB8fHx8MTc4NjIxNzQxOHww&ixlib=rb-4.1.0&q=85",
    desc: "Från stilla gryningsmete till kvällens första hugg – reportage från sjö och älv.",
  },
  {
    slug: "skapande",
    label: "Skapande",
    num: "02",
    img: "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx3b29kd29ya2luZyUyMGhhbmRzJTIwY3JhZnR8ZW58MHx8fHwxNzg2MjE3NDE5fDA&ixlib=rb-4.1.0&q=85",
    desc: "Trä, kåda och tålamod. Det som växer fram mellan händerna.",
  },
  {
    slug: "ovrigt",
    label: "Övrigt",
    num: "03",
    img: HERO_IMG,
    desc: "Allt däremellan – vandringar, tankar och vardagsvildmark.",
  },
];

export const CATEGORY_LABELS = { fiske: "Fiske", skapande: "Skapande", ovrigt: "Övrigt" };

export const CATEGORY_FALLBACK_IMG = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c.img]));

export const formatDate = (iso, lang = "sv") =>
  new Date(iso).toLocaleDateString(lang === "en" ? "en-GB" : "sv-SE", { day: "numeric", month: "long", year: "numeric" });
